import FsLightbox from 'fslightbox-react'
import React, { useState } from 'react'
import { Modal } from 'react-bootstrap'
import styled from 'styled-components'
import { CoinComponent } from '../Gamification/CoinComponent'

const StyledModal = styled(Modal)`
  .imgBtn {
    background: transparent;
    border: none;
    img {
      transition: all 200ms;
    }

    &:hover img {
      transform: scale(1.1);
    }
  }
  .modal-content {
    background: transparent;
    border: none;
  }
  h5 {
    background-color: #fff;
    text-align: center;
    padding: 24px;
    border-radius: 20px;
  }
  .carousel-control-next,
  .carousel-control-prev {
    opacity: 1;
  }
  .carousel-control-prev {
    left: -10%;
  }
  .carousel-control-next {
    right: -10%;
  }
  /* span.carousel-control-next-icon, span.carousel-control-prev-icon {
    background-color: #F83636;
    padding: 12px;
    border: 4px solid #F83636;
    border-radius: 4px;
  } */
`

export default function PosterModal({ mission, galleryType, images, posterOpen, setPosterOpen }) {
  const [toggler, setToggler] = useState(false)
  const [current, setCurrent] = useState(0)

  return (
    <StyledModal show={posterOpen} onHide={() => setPosterOpen(false)} aria-labelledby="images-modal" centered size={galleryType === 'wallpaper' ? 'lg' : 'md'}>
      {galleryType === 'wallpaper' && mission.mission_type === 'image_gallery' && <CoinComponent mission={mission} />}
      <Modal.Body>
        <FsLightbox
          toggler={toggler}
          sources={images.map((poster) => (
            <img src={poster.url} alt="poster" />
          ))}
          sourceIndex={current}
        />
        {images.length > 0 ? (
          <>
            {images.length > 1 ? (
              <div className="row">
                {images.map((poster, index) => (
                  <div className="col-6 my-2">
                    <button
                      onClick={() => {
                        setToggler(!toggler)
                        setCurrent(index)
                      }}
                      key={`poster-${index}`}
                      className="imgBtn"
                    >
                      <img src={poster.url} alt={`poster-${index}`} width="100%" />
                    </button>
                  </div>
                ))}
              </div>
            ) : (
              <button
                onClick={() => {
                  setToggler(!toggler)
                  setCurrent(0)
                }}
                className="imgBtn d-block mx-auto"
              >
                <img src={images[0].url} alt="poster" width="100%" />
              </button>
            )}
          </>
        ) : (
          <h5>No poster available.</h5>
        )}
      </Modal.Body>
    </StyledModal>
  )
}
